import React from 'react';
import { NextPage, NextPageContext } from 'next';
import { PageHead } from '../../features/Layout';
import {
  serviceLoader,
  ServiceLoaderProps,
} from '../../features/ProviderDirectory/providerDirectoryLoaders';
import {
  useDescription,
  ProviderDirectory,
} from '../../features/ProviderDirectory/ProviderDirectory';
import type { ProvidersDirectoryType } from '../../features/ProviderDirectory/types';
import { useProvidersLayoutContext } from '../../features/ProviderDirectory/useProvidersLayoutContext';

export const ProviderDirectoryPage: NextPage<{
  providers?: ProvidersDirectoryType;
}> = ({ providers }) => {
  useProvidersLayoutContext();
  const DESCRIPTION = useDescription();
  return (
    <>
      <PageHead title="Provider Directory" description={DESCRIPTION} />
      <ProviderDirectory {...(providers as ProvidersDirectoryType)} />
    </>
  );
};

ProviderDirectoryPage.getInitialProps = async ({
  smartlingLanguage,
  preview = false,
}: NextPageContext & { preview?: boolean; smartlingLanguage: string }) => {
  const serviceLoaderProps = {
    preview: preview,
    smartlingLanguage: smartlingLanguage,
  } as ServiceLoaderProps;
  const providers =
    ((await serviceLoader.load(
      serviceLoaderProps,
    )) as ProvidersDirectoryType) || undefined;
  return {
    providers,
    preview,
  };
};

export default ProviderDirectoryPage;
